import { GET_SALE_ORDER_HISTORY } from './actions'

const initialState = {
  total: 0,
  sale_order_history: [],
  loading_get_sale_order_history: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SALE_ORDER_HISTORY.REQUEST:
      return {
        ...state,
        loading_get_sale_order_history: true,
      }
    case GET_SALE_ORDER_HISTORY.SUCCESS:
      return {
        ...state,
        total: action.payload.lists.total,
        sale_order_history: action.payload.lists.data,
        loading_get_sale_order_history: false,
      }
    case GET_SALE_ORDER_HISTORY.FAILURE:
      return {
        ...state,
        // ล้างของเก่าทิ้ง — ค้างไว้แล้ว user นึกว่าเป็นผลของเงื่อนไขที่เพิ่งค้นหา
        total: 0,
        sale_order_history: [],
        loading_get_sale_order_history: false,
      }
    default:
      return state
  }
}
